import classNames from 'classnames';

import type { EventReportHeaderSkeletonProps } from './event-report-header-skeleton.type';

export const EventReportHeaderSkeleton = ({
  imageAspectRatio = 'landscape',
  showAnchorBar = true,
}: EventReportHeaderSkeletonProps) => {
  return (
    <>
      <div className='flex flex-col sm:flex-row gap-6 mb-6 md:mb-8 px-4'>
        <div
          className={classNames('grow-0 shrink-0 animate-pulse', {
            'w-full sm:w-80 md:w-64 lg:w-[171px] aspect-[16/9]': imageAspectRatio === 'landscape',
            'w-full sm:size-32 lg:size-39 aspect-square': imageAspectRatio === 'square',
          })}>
          <div className='w-full h-full bg-tertiary rounded-lg' />
        </div>
        <header className='flex flex-col grow self-start sm:self-auto w-full'>
          <div className='w-full h-full flex gap-3 md:gap-10 items-start lg:items-center justify-between'>
            <div className='flex flex-col w-full md:w-auto gap-3 animate-pulse'>
              <div className='h-5 bg-tertiary w-32 rounded-sm'></div>
              <div className='flex gap-x-3 justify-between items-center w-full'>
                <div className='h-7 md:h-8 lg:h-9 bg-tertiary w-full max-w-lg rounded-sm'></div>
              </div>
              <div className='flex flex-wrap gap-x-3 gap-y-1'>
                <div className='h-6 bg-tertiary w-36 rounded-sm'></div>
                <div className='h-6 bg-tertiary w-36 rounded-sm'></div>
                <div className='h-6 bg-tertiary w-44 rounded-sm'></div>
              </div>
            </div>
            <div className='hidden md:flex gap-2 shrink-0 animate-pulse'>
              <div className='w-16 h-9 bg-tertiary rounded-sm'></div>
              <div className='w-24 h-9 bg-tertiary rounded-sm'></div>
              <div className='w-9 h-9 bg-tertiary rounded-sm'></div>
            </div>
          </div>
        </header>
      </div>
      {showAnchorBar && <div className='h-14 bg-tertiary rounded-sm w-full mb-8 md:mb-20 animate-pulse'></div>}
    </>
  );
};
